import type { MatchCardsListsAppenderComponent } from "@motain/xpa-proto-files-web/lib/types/match_cards_lists_appender";

/*
  Imports runtime/match_cards_lists_appender and returns the decode function
  XPA has not a proper three shaking, so when you import runtime it imports a lot of unnecessary javascript, so to
  avoid blocking the page rendering we import it asynchronously
*/
export async function lazyInitMatchCardsListsAppenderRuntime(): Promise<
  (input: Uint8Array, length?: number) => MatchCardsListsAppenderComponent
> {
  const [
    {
      MatchCardsListsAppenderComponent: { decode },
    },
  ] = await Promise.all([
    import(
      "@motain/xpa-proto-files-web/lib/runtime/match_cards_lists_appender"
    ),
  ]);
  return decode;
}
